export class ViewModelFiltraCobranca {
    idModulo: number;
    idContribuicao: number;
    dtRefInicio: string;
    dtRefFim: string;
    cpf: string;
    idPlano: number;
    idEmp: number;
    dtVencInicio: string;
    dtVencFim: string;
    dtPagInicio: string;
    dtPagFim: string;
    dtCancInicio: string;
    dtCancFim: string;
    parcela: number;
    contrato: number;
    valorIninico: number;
    valorFim: number;
    idModoLiquidacao: number;
    nome: string;
    icQuitacao: string;
    icPrestacao: string;
    icAntecipacao: string;
    icInadimplente: string;
    icRegistrado: string;
    icLiberado: string;
    icCalculado: string;
    dtCompetencia:string;
}